import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import GoBillionCoinsGuidelines from "./components/GoBillionCoinsGuidelines/GoBillionCoinsGuidelines";
import Layout from "./components/Layout/Layout";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import CancellationPolicy from "./components/CancellationPolicy/CancellationPolicy";
import "./newcss.css";

const App = () => {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route path="/gobillioncoinsguidelines.html" element={<GoBillionCoinsGuidelines />} />
          <Route path="/term.html" element={<TermsAndConditions />} />
          <Route path="/privacy-policy.html" element={<PrivacyPolicy />} />
          <Route path="/cancellation-policy.html" element={<CancellationPolicy />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
